import type { FaireProductEntity } from "../../entity_types/product";

export const p_vsp93am2rx: FaireProductEntity = {
  token: "p_vsp93am2rx",
  type: "product",
  name: "Basil Lemonade",
  brandToken: "b_yjjy7kddvy",
  brandName: "Rustic Pours",
  imageUrl:
    "https://cdn.faire.com/fastly/7090115c0496fba881ff35d78c94ea6caa47b450e09b4f3fc3416aadd540361a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5bf009f684a3769ed6e9c29652ae5bd9959016fe787833b73a944be23c786ee4.jpeg",
    "https://cdn.faire.com/fastly/f8483ab74dafd12b8ec10d9f0d1b805539ed442163ce0617ef7aa3523be1af15.jpeg",
    "https://cdn.faire.com/fastly/858c16a60b339bfbf9222aa9796859b68679dee489ce9e74d5ea52a6e7727625.jpeg",
    "https://cdn.faire.com/fastly/ea8fb4d7492a803eba007d6abfd3990c8b5dd7f16706ed038901f8ed0373b23e.jpeg",
    "https://cdn.faire.com/fastly/49fb7b857edfded5082d1ed9f937c64271471d2eb9188933d571b204f02cef63.jpeg",
    "https://cdn.faire.com/fastly/777ab79fab720c30a35493de6dee08e1e78190b1ff4d8e132eff426c034844df.jpeg",
    "https://cdn.faire.com/fastly/63d22622b107970e99cf879bf12351b89ce0e284e9a7460056cd11b28074e60c.jpeg",
  ],
  priceDollars: 77.6,
  description:
    "12 beverages per case for ultimate convenience: Chill, Sip, and Savor!\nBright, refreshing and subtly herbaceous, our Basil Lemonade pairs the crisp tang of fresh lemons with the botanical notes of basil. Crafted for those who seek a sophisticated, artisanal twist on a classic favorite, this lemonade is naturally balanced, lightly sweetened and perfect for sipping on its own or elevating cocktails, mocktails, and culinary creations. Shelf stable and can be enjoyed cold or warm a year round favorite. Rustic Pours Basil lemonade is designed for retailers who want a high-quality, crowd pleasing beverage that stands out open shelves and menus alike. Our lemonade is conveniently packaged 12 bottles to a case- a perfectly curated dozen ready to chill, share and savor",
  tags: [],
  msrpDollars: 127.48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:39.347Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
